'use client';

import { ProviderId } from '../model';
import { useYandexRuntime } from '../providers';

const useAnalyticsInit = (providerIds: ProviderId[]) => {
  useYandexRuntime(providerIds.includes(ProviderId.Yandex));
};

export default useAnalyticsInit;
